/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstanceWithZone } from "./ForcingSubstanceWithZone";
import {
  ForcingSubstanceWithZoneFromJSON,
  ForcingSubstanceWithZoneFromJSONTyped,
  ForcingSubstanceWithZoneToJSON,
  ForcingSubstanceWithZoneToJSONTyped,
} from "./ForcingSubstanceWithZone";
import type { TimeseriesRainMsUnitEnum } from "./TimeseriesRainMsUnitEnum";
import {
  TimeseriesRainMsUnitEnumFromJSON,
  TimeseriesRainMsUnitEnumFromJSONTyped,
  TimeseriesRainMsUnitEnumToJSON,
  TimeseriesRainMsUnitEnumToJSONTyped,
} from "./TimeseriesRainMsUnitEnum";

/**
 * EventMixin which converts a timeseries-event into a contstant-event.
 *
 * Behind the scenes constant and timeseries are the same but shown to the user as 2
 * different types for ease of configuration.
 * In a constant-event the user provides a `value` and `duration`, whereas in a
 * timeseries-event the user provides nested array as `values`. This mixin converts
 * the `value` and `duration` of a constant-event into a timeseries similar as a
 * timeseries event.
 *
 * The timeseries will look as following:
 * `values = [[0, value], [duration, 0]]`
 *
 * Requires the fields:
 * - interpolate
 * - constant
 * - value
 * - values
 * - duration
 * @export
 * @interface ConstantRain
 */
export interface ConstantRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration: number | null;
  /**
   * Rain intensity
   */
  value: number;
  /**
   * m/s is only option for now
   *
   * * `m/s` - m/s
   */
  units: TimeseriesRainMsUnitEnum;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstanceWithZone>;
}

/**
 * Check if a given object implements the ConstantRain interface.
 */
export function instanceOfConstantRain(value: object): value is ConstantRain {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("duration" in value) || value["duration"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("units" in value) || value["units"] === undefined) return false;
  return true;
}

export function ConstantRainFromJSON(json: any): ConstantRain {
  return ConstantRainFromJSONTyped(json, false);
}

export function ConstantRainFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConstantRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    duration: json["duration"],
    value: json["value"],
    units: TimeseriesRainMsUnitEnumFromJSON(json["units"]),
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceWithZoneFromJSON),
  };
}

export function ConstantRainToJSON(json: any): ConstantRain {
  return ConstantRainToJSONTyped(json, false);
}

export function ConstantRainToJSONTyped(
  value?: Omit<ConstantRain, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    value: value["value"],
    units: TimeseriesRainMsUnitEnumToJSON(value["units"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceWithZoneToJSON),
  };
}
